import Process from 'models/process/process';
import Risk from 'models/risk';
import Asset from './asset';
import ProcessingActivity from 'models/processingActivity';

export class AssetContext {
  assets: Asset[];

  risks: Risk[];

  processes: Process[];

  processingActivitiesData: ProcessingActivity[];
  
  processingActivitiesRecipient: ProcessingActivity[];

  processingActivitiesProcessor: ProcessingActivity[];

  processingActivitiesJointController: ProcessingActivity[];

  constructor() {
    this.assets = []; 
    this.risks = [];
    this.processes = [];
    this.processingActivitiesData = [];
    this.processingActivitiesRecipient = [];
    this.processingActivitiesProcessor = [];
    this.processingActivitiesJointController = [];
  }
}
